import request from '@/axios';
import func from '@/utils/func';
import dayjs from 'dayjs';

export const getReportDataPage = (data) => {
  return request({
    url: '/emp-business/blade-report/report/reportData',
    method: 'post',
    data,
  });
};

export const getReportDataDetail = (params) => {
  return request({
    url: '/emp-business/blade-report/report/detail',
    method: 'get',
    params,
  });
};

export const reportSubmit = (data) => {
  return request({
    url: '/emp-business/blade-report/report/submit',
    method: 'post',
    data,
  });
};

export const removeReport = (ids) => {
  return request({
    url: '/emp-business/blade-report/report/removeRepot',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const submitReportModuleItem = (data) => {
  return request({
    url: '/emp-business/blade-report/report/submitReportModuleItem',
    method: 'post',
    data,
  });
};

export const removeReportModuleItem = (ids) => {
  return request({
    url: '/emp-business/blade-report/report/removeReportModuleItem',
    method: 'post',
    params: {
      ids,
    }
  });
};

export const energyAnalysis = (data) => {
  return request({
    url: '/emp-business/project/energy/anlysis',
    method: 'post',
    data
  });
};

export const eleJfpgReport = (data) => {
  return request({
    url: '/emp-business/eleJfpg/report',
    method: 'post',
    data,
    filterEmptyParams: true,
  });
};


function getTimes(dataType) {
  const data = {};
  const current = new Date().getTime()
  if (dataType === '5') {
    // 小时类型拼当天开始结束时间
    data.etime = dayjs(current).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    data.stime = dayjs(current).startOf('day').format('YYYY-MM-DD HH:mm:ss');
  } else if (dataType === '6') {
    // 天类型拼当月开始结束时间
    data.etime = dayjs(current).endOf('month').format('YYYY-MM-DD HH:mm:ss');
    data.stime = dayjs(current).startOf('month').format('YYYY-MM-DD HH:mm:ss');
  } else if (dataType === '7') {
    // 天类型拼当年开始结束时间
    data.etime = dayjs(current).endOf('year').format('YYYY-MM-DD HH:mm:ss');
    data.stime = dayjs(current).startOf('year').format('YYYY-MM-DD HH:mm:ss');
  }
  return data;
}

export const getEleJfpgData = (data) => {
  data.dataType = data.dateType;
  const times = getTimes(data.dataType)
  delete data.dateType;
  const param = Object.assign(data, times)
  return request({
    url: '/emp-business/eleJfpg/getEleJfpgData',
    method: 'post',
    data: param,
    filterEmptyParams: true,
  });
};

export const jfpgBarGraph = (data) => {
  data.dataType = data.dateType;
  const times = getTimes(data.dataType);
  delete data.dateType;
  const param = Object.assign(data, times)
  return request({
    url: '/emp-business/eleJfpg/barGraph',
    method: 'post',
    data: param,
    filterEmptyParams: true,
  });
};